import {
  Badge,
  Box,
  Button,
  Divider,
  Flex,
  Grid,
  Menu,
  Select,
  Textarea,
} from "@mantine/core";
import { IconCheck, IconDots, IconX } from "@tabler/icons-react";
import { useState } from "react";
import { repositoryDelivery } from "../../../_base/_const/_constVar";
import { MessageResponse } from "../../../model/MessageResponse";

interface updateStatusCTKM {
  codes: string[];
  status: string;
  note: string;
}

const UpdateStatus = ({
  codes,
  status,
  fetchData,
  setSelectMenu,
  setOpenMenu,
}: {
  codes: string[];
  status: string;
  fetchData: any;
  setSelectMenu?: any;
  setOpenMenu?: any;
}) => {
  const getValueStatus = (value: string) => {
    switch (value) {
      case "Chua duyet":
        return "1";
      case "Da duyet":
        return "2";
      case "Tam dung":
        return "3";
      case "Tu choi":
        return "4";
      case "Huy duyet":
        return "5";
      case "":
        return "";
    }
  };

  const [dataSubmit, setDataSubmit] = useState<updateStatusCTKM>({
    codes: codes,
    status: getValueStatus(status) ?? "",
    note: "",
  });
  const [loadingButton, setLoadingButton] = useState<boolean>(false);

  const handleSubmit = async () => {
    setLoadingButton(true);
    const res = await repositoryDelivery.post<
      MessageResponse<updateStatusCTKM>
    >("/api/v1/TblPromotion/update-status", dataSubmit);

    if (res && res.success) {
      setLoadingButton(false);
      fetchData("Cập nhật trạng thái thành công !");
      if (setSelectMenu) {
        setSelectMenu(-1);
      }

      if (setOpenMenu) {
        setOpenMenu(false);
      }
    } else {
      setLoadingButton(false);
    }
  };

  return (
    <Box w={"100%"} p={10}>
      <Flex
        justify={"center"}
        align={"center"}
        w={"100%"}
        direction={"column"}
        gap={"5px"}
      >
        {codes.length === 1 ? (
          <Badge color={"blue"} radius="sm" variant="dot" size="lg">
            {codes[0]}
          </Badge>
        ) : (
          <Grid w={codes.length > 6 ? 475 : 455} justify="center">
            {codes.length < 6
              ? codes?.map((item, index) => (
                  <Grid.Col span={4} key={index}>
                    <Badge
                      color={"blue"}
                      radius="sm"
                      variant="dot"
                      size="lg"
                      key={index}
                      w={"100%"}
                    >
                      {item}
                    </Badge>
                  </Grid.Col>
                ))
              : codes.length === 6
              ? codes.slice(0, 6)?.map((item, index) => (
                  <Grid.Col span={4} key={index}>
                    <Badge
                      color={"blue"}
                      radius="sm"
                      variant="dot"
                      size="lg"
                      key={index}
                      w={"100%"}
                    >
                      {item}
                    </Badge>
                  </Grid.Col>
                ))
              : codes.slice(0, 5)?.map((item, index) => (
                  <Grid.Col span={4} key={index}>
                    <Badge
                      color={"blue"}
                      radius="sm"
                      variant="dot"
                      size="lg"
                      key={index}
                      w={"100%"}
                    >
                      {item}
                    </Badge>
                  </Grid.Col>
                ))}
            {codes.length > 6 ? (
              <Grid.Col span={4}>
                <Menu trigger="hover" width={500}>
                  <Menu.Target>
                    <Button
                      color="blue"
                      leftSection={<IconDots size={14} />}
                      size="xs"
                      h={25}
                      w={"100%"}
                    >
                      Xem thêm
                    </Button>
                  </Menu.Target>
                  <Menu.Dropdown>
                    <Grid>
                      {codes.slice(6)?.map((item, index) => (
                        <Grid.Col span={4} key={index}>
                          <Badge
                            color={"blue"}
                            radius="sm"
                            variant="dot"
                            size="lg"
                            key={index}
                            w={"100%"}
                          >
                            {item}
                          </Badge>
                        </Grid.Col>
                      ))}
                    </Grid>
                  </Menu.Dropdown>
                </Menu>
              </Grid.Col>
            ) : (
              <></>
            )}
          </Grid>
        )}

        <Divider
          label="Cập nhật trạng thái CTKM"
          labelPosition="center"
          w={455}
        />
        <Select
          label="Trạng thái CTKM"
          placeholder="Chọn trạng thái CTKM"
          data={[
            {
              value: "1",
              label: "Chưa duyệt",
            },
            {
              value: "2",
              label: "Đã duyệt",
            },
            {
              value: "3",
              label: "Tạm dừng",
            },
            {
              value: "4",
              label: "Từ chối",
            },
            {
              value: "5",
              label: "Hủy duyệt",
            },
          ]}
          value={dataSubmit.status}
          onChange={(e) =>
            setDataSubmit((prev) => ({
              ...prev,
              status: e ? e : status,
            }))
          }
          w={455}
        />
        <Textarea
          label="Ghi chú"
          placeholder="Nhập ghi chú"
          value={dataSubmit.note}
          onChange={(e) =>
            setDataSubmit((prev) => ({ ...prev, note: e.currentTarget.value }))
          }
          w={455}
        />
        <Flex justify={"center"} align={"center"} gap={"md"}>
          <Button
            variant="filled"
            color="teal"
            leftSection={<IconCheck size={14} />}
            onClick={() => handleSubmit()}
            disabled={loadingButton}
            loading={loadingButton}
            size="xs"
          >
            Xác nhận
          </Button>
          <Button
            variant="filled"
            color="red"
            leftSection={<IconX size={14} />}
            onClick={() => {
              if (setSelectMenu) {
                setSelectMenu(-1);
              }

              if (setOpenMenu) {
                setOpenMenu(false);
              }
            }}
            size="xs"
          >
            Đóng
          </Button>
        </Flex>
      </Flex>
    </Box>
  );
};

export default UpdateStatus;
